/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
    
  // PRODUCT - autoplay video in thumbnail
  var productVideoPlayButton = document.querySelector(".product__images button.deferred-media__poster");
  
  if (window.matchMedia("(min-width: 747px)").matches) {
    window.addEventListener('load', function () {
      if (productVideoPlayButton) {
        productVideoPlayButton.click();
      };
    });
  };



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
